import { render, staticRenderFns } from "./Blogd.vue?vue&type=template&id=52d70db2&"
import script from "./Blogd.vue?vue&type=script&lang=js&"
export * from "./Blogd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports